<template>
  <form
    class="office-search-form"
    :class="{ 'office-search-form--loading': loading }"
    @submit.prevent="onSubmit"
  >
    <div class="row">
      <div class="col-12 col-md-5 col-lg-4 offset-lg-2">
        <label
          class="sr-only"
          for="workstations"
        >
          {{ i18n.workstationsLabel }}
        </label>

        <div
          class="office-search-form__input-holder"
          :class="{
            'office-search-form__input-holder--invalid': $v.workstations.$error
          }"
        >
          <input
            id="workstations"
            v-model="workstations"
            class="office-search-form__input office-search-form__input--ico"
            type="number"
            name="workstations"
            :placeholder="i18n.workstationsPlaceholder"
            @input="$v.workstations.$touch()"
          >
        </div>
      </div>
      <!-- /.col -->

      <div class="col-12 col-md-5 col-lg-4">
        <label class="sr-only">
          {{ i18n.cityLabel }}
        </label>

        <div
          class="office-search-form__input-holder"
          :class="{ 'office-search-form__input-holder--invalid': $v.location.$error }"
        >
          <slot
            name="city-select"
            :on-change="locationSelectOnChange"
          />
        </div>
      </div>
      <!-- /.col -->

      <div class="col-12 col-md-2 col-lg-1">
        <button
          class="office-search-form__button"
          :class="{ 'button--loading': loading }"
          type="submit"
          :disabled="loading"
        >
          <span class="sr-only">
            {{ i18n.search }}
          </span>
        </button>
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->
  </form>
  <!-- /.office-search-form -->
</template>

<script>
import { numeric, required } from 'vuelidate/lib/validators';
import validatorUtils from '../js/mixins/validatorUtils';
import props from './office-search-form-props';

export default {
  name: 'SearchFormBase',
  mixins: [
    validatorUtils,
  ],
  props,
  data() {
    return {
      workstations: '',
      location: {
        id: null,
        region: null,
        city: null,
        country: null,
      },
      loading: false,
    };
  },
  validations: {
    workstations: {
      required,
      numeric,
    },
    location: {
      required,
    },
  },
  methods: {
    locationSelectOnChange({
      id, region, city, country,
    }) {
      if (!id) {
        return;
      }

      this.location = {
        id,
        region,
        city,
        country,
      };
      this.$v.location.$touch();
    },
    onSubmit() {
      if (this.$v.$invalid) {
        this.touchAll();
        return;
      }
      this.submit();
    },
    submit() {
      const query = new URLSearchParams({
        count: this.workstations,
        region: this.location.region,
        city: this.location.city,
        country: this.location.country,
      }).toString();

      window.location = `${this.submitUrl}?${query}`;
    },
  },
};

</script>
